<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/trade/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    export default {
        name: 'demo',
        components: {
            tablePage,
            FORM,
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if("重置" == clickName){
                    this.formData.cols = this.getDefaultFrom();
                }
            },
            //获取默认查询条件
            getDefaultFrom(){
                return [
                    { title: "开户开始时间", field: 'startCtime',type: 5,data:new Date(new Date().toLocaleDateString()).getTime()},
                    { title: "开户结束时间", field: 'endCtime',type: 5,data:new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1},
                    { title: "激活开始时间", field: 'sttartActiveTime',type: 5},
                    { title: "激活结束时间", field: 'endActiveTime',type: 5},
                    { title: "用户账号", field: 'id'},
                    { title: "代理", field: 'agent'},
                    { title: "手机号", field: 'mobilePhone'},
                    { title: "开户来源", field: 'utmSource'},
                    { title: "媒介", field: 'utmMedium'},
                    { title: "广告组", field: 'utmCampaign'},
                    { title: "广告系列", field: 'utmContent'},
                    { title: "关键字", field: 'utmTerm'},
                    {click:"重置"},
                    {click:"查询"}
                ]
            },
        },
        created(){
            this.formData.cols = this.getDefaultFrom();
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                    //hasLable: true,
                    cols:[]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.account.demoQuery, //请求路径和参数
                    selection: false,
                    sequence: true,
                    cols: [
                        { title: "用户账号", field: 'id'},
                        { title: "代理", field: 'agent'},
                        { title: "姓名", field: 'englishFirstName',render:(data,full)=> {
                                return full.englishFirstName +"." + full.englishLastName;
                            }},
                        { title: "手机号", field: 'mobilePhone'},
                        { title: "邮箱", field: 'email'},
                        { title: "账户级别", field: 'accountLevel'},
                        { title: "账户状态", field: 'accountStatus'},
                        { title: "账户币种", field: 'currency'},
                        { title: "开户时间", field: 'ctime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        { title: "ip", field: 'ip'},
                        { title: "ip所属地", field: 'ipAddress'},
                        { title: "开户地址", field: 'href'},
                        { title: "开户来源", field: 'utmSource'},
                        { title: "媒介", field: 'utmMedium'},
                        { title: "广告组", field: 'utmCampaign'},
                        { title: "广告系列", field: 'utmContent'},
                        { title: "关键字", field: 'utmTerm'},
                        { title: "浏览器信息", field: 'userAgent'},
                        { title: "激活时间", field: 'activeTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        { title: "直接推荐人", field: 'directAccount'},
                        { title: "直接推荐人手机号", field: 'directPhone'},
                        { title: "间接推荐人", field: 'inDirectAccount'},
                        { title: "间接推荐人手机号", field: 'inDirectPhone'},
                    ]
                }
            }
        }
    }
</script>
